var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-chips"},[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),_c('div',{staticClass:"base-chips__cross",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }